import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { ThemeProvider as MuiThemeProvider } from 'uiKit/atoms/ThemeProvider/ThemeProvider';
import { CssBaseline } from 'uiKit/atoms/CssBaseline/CssBaseline';
import { getThemeByMode } from './themes';
import { useStores } from 'stores';


export const ThemeProvider: React.FC<React.PropsWithChildren> = observer(
  ({ children }) => {
    const { themeStore} = useStores();

    const theme = useMemo(() => getThemeByMode(themeStore.themeMode), [
      themeStore.themeMode,
    ]);

    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline/>
        {children}
      </MuiThemeProvider>
    );
  }
);